import {
  Deck,
  Slide,
  Title,
  Subtitle,
  Image,
  Columns,
  List,
  Text,
  Highlight,
  Video,
  Code,
  Footer,
  Quote
} from "@sambego/diorama";

import permission from "./img/permission.webm";
import cc from "./img/cc.svg";
import sam from "./img/sam.png";
import auth0 from "./img/auth0.svg";
import auth0Roles from "./img/auth0-roles.png";
import auth0RolesUser from "./img/auth0-roles-user.png";
import auth0RolesPremium from "./img/auth0-roles-premium.png";
import auth0RBAC from "./img/auth0-rbac.png";
import googleScopes from "./img/google-scopes.png";

function Presentation() {
  const theme = "#5FB3B3";
  const themeLight = "rgba(95,179,179, .4)";
  return (
    <Deck
      // presenterNotes
      footer={
        <Footer
          left={<Highlight color={theme}>@sambego</Highlight>}
          right={<Highlight color={theme}>access.sambego.tech</Highlight>}
        />
      }
    >
      <Slide style={{ background: theme, color: "#fff" }}>
        {/* <Video
          src={permission}
          loop
          autoplay
          full
          color={theme}
          style={{ overflow: "hidden", zIndex: 1 }}
        /> */}
        <Title style={{ color: "#ffffff", position: "relative", zIndex: 1 }}>
          That's out of scope!
        </Title>
        {/* <Image
          src={cc}
          style={{
            position: "fixed",
            bottom: "2rem",
            left: "2rem",
            width: "10%",
            zIndex: 2,
          }}
          alt="Creative commons"
        /> */}
      </Slide>
      <Slide notes="Security, Privacy, Payments, and Identity">
        <Columns>
          <div>
            <Image src={sam} alt="A picture of me" full color={theme} />
          </div>
          <div>
            <Subtitle>Sam Bellen</Subtitle>
            <List>
              <li>Developer Advocate Engineer</li>
              <li>Auth0</li>
              <li>GDE</li>
              <li>@sambego</li>
            </List>
          </div>
        </Columns>
      </Slide>
      <Slide>
        <Text>
          <img src={auth0} alt="Auth0 logo" style={{height: '7rem', verticalAlign: 'middle', marginBottom: '9px'}}/> has a virtual booth. <br/>Come find us in the Partners Village.
        </Text>
      </Slide>
      <Slide>
        <Subtitle>Summary</Subtitle>
        <List>
          <li>Attribute Based Access Control</li>
          <li>Role Based Access Control</li>
          <li>Permissions vs Scopes</li>
        </List>
      </Slide>

      
     <Slide style={{ background: theme }}>
        <Subtitle style={{ letterSpacing: "4rem" }}>Access Control</Subtitle>
     </Slide>
     <Slide><Text><Highlight color={theme}>Access control</Highlight> is the art of regulating <Highlight color={theme}>who can do what</Highlight> on your system.</Text></Slide>
     
     <Slide style={{ background: theme }}>
        <Subtitle style={{ letterSpacing: "4rem" }}>ABAC</Subtitle>
      </Slide>
      <Slide><Subtitle><Highlight color={theme}>Attribute</Highlight> Based Access Control</Subtitle></Slide>
      <Slide><Subtitle><Highlight color={theme}>Policy</Highlight> Based Access Control</Subtitle></Slide>
      <Slide>
        <Subtitle>Attributes</Subtitle>
        <List>
          <li>User</li>
          <li>Environment</li>
          <li>Resource</li>
          <li>Actions</li>
        </List>
      </Slide>
      <Slide>
        <Subtitle>User</Subtitle>
        <List>
          <li>Role</li>
          <li>Organization</li>
          <li>Security Clearance</li>
          <li>...</li>
        </List>
      </Slide>
      <Slide>
        <Subtitle>Environment</Subtitle>
        <List>
          <li>Time of day</li>
          <li>Location of the data</li>
          <li>Current thread level</li>
          <li>...</li>
        </List>
      </Slide>
      <Slide>
        <Subtitle>Resource</Subtitle>
        <List>
          <li>Creation date</li>
          <li>Owner</li>
          <li>Data sensitivity</li>
          <li>...</li>
        </List>
      </Slide>
      <Slide>
        <Subtitle>Action</Subtitle>
        <List>
          <li>Read</li>
          <li>Write</li>
          <li>Delete</li>
          <li>...</li>
        </List>
      </Slide>
      <Slide><Text>Any engineer can write to any file, if we are currently not experiencing a DDOS attack.</Text></Slide>
      <Slide notes="User"><Text><Highlight color={theme}>Any engineer</Highlight> can <Highlight color={themeLight}>write</Highlight> to <Highlight color={themeLight}>any file</Highlight>, if we are currently <Highlight color={themeLight}>not experiencing a DDOS attack</Highlight>.</Text></Slide>
      <Slide notes="Action"><Text><Highlight color={themeLight}>Any engineer</Highlight> can <Highlight color={theme}>write</Highlight> to <Highlight color={themeLight}>any file</Highlight>, if we are currently <Highlight color={themeLight}>not experiencing a DDOS attack</Highlight>.</Text></Slide>
      <Slide notes="Resource"><Text><Highlight color={themeLight}>Any engineer</Highlight> can <Highlight color={themeLight}>write</Highlight> to <Highlight color={theme}>any file</Highlight>, if we are currently <Highlight color={themeLight}>not experiencing a DDOS attack</Highlight>.</Text></Slide>
      <Slide notes="Emvironmen"><Text><Highlight color={themeLight}>Any engineer</Highlight> can <Highlight color={themeLight}>write</Highlight> to <Highlight color={themeLight}>any file</Highlight>, if we are currently <Highlight color={theme}>not experiencing a DDOS attack</Highlight>.</Text></Slide>
      
      
      <Slide><Text>An accountant can upload an invoice, if it is during their working hours.</Text></Slide>
      <Slide notes="User"><Text>An <Highlight color={theme}>accountant</Highlight> can <Highlight color={themeLight}>upload</Highlight> <Highlight color={themeLight}>an invoice</Highlight>, if it is <Highlight color={themeLight}>during their working hours</Highlight>.</Text></Slide>
      <Slide notes="Action"><Text>An <Highlight color={themeLight}>accountant</Highlight> can <Highlight color={theme}>upload</Highlight> <Highlight color={themeLight}>an invoice</Highlight>, if it is <Highlight color={themeLight}>during their working hours</Highlight>.</Text></Slide>
      <Slide notes="Resource"><Text>An <Highlight color={themeLight}>accountant</Highlight> can <Highlight color={themeLight}>upload</Highlight> <Highlight color={theme}>an invoice</Highlight>, if it is <Highlight color={themeLight}>during their working hours</Highlight>.</Text></Slide>
      <Slide notes="Environment"><Text>An <Highlight color={themeLight}>accountant</Highlight> can <Highlight color={themeLight}>upload</Highlight> <Highlight color={themeLight}>an invoice</Highlight>, if it is <Highlight color={theme}>during their working hours</Highlight>.</Text></Slide>
      
      
      <Slide><Text>A HR representative can look up personal details, if the subject is part of their local branch.</Text></Slide>
      <Slide notes="User"><Text>A <Highlight color={theme}>HR representative</Highlight> can <Highlight color={themeLight}>look up</Highlight> <Highlight color={themeLight}>personal details</Highlight>, if the subject <Highlight color={themeLight}>is part of their local branch</Highlight>.</Text></Slide>
      <Slide notes="Action"><Text>A <Highlight color={themeLight}>HR representative</Highlight> can <Highlight color={theme}>look up</Highlight> <Highlight color={themeLight}>personal details</Highlight>, if the subject <Highlight color={themeLight}>is part of their local branch</Highlight>.</Text></Slide>
      <Slide notes="Resource"><Text>A <Highlight color={themeLight}>HR representative</Highlight> can <Highlight color={themeLight}>look up</Highlight> <Highlight color={theme}>personal details</Highlight>, if the subject <Highlight color={themeLight}>is part of their local branch</Highlight>.</Text></Slide>
      <Slide notes="Environment"><Text>A <Highlight color={themeLight}>HR representative</Highlight> can <Highlight color={themeLight}>look up</Highlight> <Highlight color={themeLight}>personal details</Highlight>, if the subject <Highlight color={theme}>is part of their local branch</Highlight>.</Text></Slide>
      
      
      <Slide><Text>ABAC allows for a <Highlight color={theme}>fine grained controll</Highlight> over <Highlight color={theme}>all possible actions</Highlight> on your infrastructure.</Text></Slide>
      <Slide><Text>Depending on your architecture or organization, this <Highlight color={theme}>might be overkill</Highlight>.</Text></Slide>

      <Slide style={{ background: theme }}>
        <Subtitle style={{ letterSpacing: "4rem" }}>RBAC</Subtitle>
      </Slide>
      <Slide><Subtitle><Highlight color={theme}>Role </Highlight>Based Access Control</Subtitle></Slide>
      <Slide><Text>A user has <Highlight color={theme}>one or more roles</Highlight>.</Text></Slide>
      <Slide notes="An engineer can have the engineer role, while a team lead can have both engineer and admin roles">
        <Subtitle>Roles</Subtitle>
        <List>
          <li>Admin</li>
          <li>Engineer</li>
          <li>Guest</li>
          <li>...</li>
        </List>
      </Slide>
      <Slide><Text>A role has <Highlight color={theme}>one or more permissions</Highlight>.</Text></Slide>
      <Slide notes="An engineer can read and write files, while an admin can do both those and delete files">
        <Subtitle>Permissions</Subtitle>
        <List>
          <li>Read a resource</li>
          <li>Write to a resource</li>
          <li>Delete a resource</li>
          <li>...</li>
        </List>
      </Slide>
      <Slide><Text>A <Highlight color={theme}>guest</Highlight> is able to <Highlight color={theme}>read</Highlight> all documentation.</Text></Slide>
      <Slide><Text>An <Highlight color={theme}>engineer</Highlight> is able to <Highlight color={theme}>read</Highlight> and <Highlight color={theme}>edit</Highlight> all documentation.</Text></Slide>
      <Slide><Text>An <Highlight color={theme}>admin</Highlight> is able to <Highlight color={theme}>read</Highlight>, <Highlight color={theme}>edit</Highlight> and <Highlight color={theme}>delete</Highlight> all documentation.</Text></Slide>

      <Slide><Image src={auth0Roles} contain/></Slide>
      <Slide><Image src={auth0RolesUser} contain/></Slide>
      <Slide notes="You might either only assign the premium role to premium users and add all permissions to that role, or mix the 2 roles."><Image src={auth0RolesPremium} contain/></Slide>
      
      
      <Slide>
        <Code code={`curl\n  --request GET\n  --url 'https://...auth0.com/api/v2/users/<USER_ID>/permissions'\n  --header 'authorization: Bearer <ACCESS_TOKEN>'`} />
      </Slide>
      <Slide><Image src={auth0RBAC} contain/></Slide>
      <Slide>
        <Code code={`{\n  "iss": "https://...auth0.com/",\n  ...\n  "permissions": [\n    "advertisement:read",\n    "advertisement:create",\n    "advertisement:promote"\n  ]\n}`} />
      </Slide>
      
      <Slide notes="depends on the complexity. Checking roles is easier, while checking permissions is a bit more future proof">
        <Text>Should you check <Highlight color={theme}>permissions</Highlight> or <Highlight color={theme}>roles</Highlight> on your API or Application?</Text>
      </Slide>

      
      <Slide style={{ background: theme }}>
        <Subtitle style={{ letterSpacing: "4rem" }}>Permissions<span style={{display: 'block', margin: '2rem 0'}}>VS</span>Scopes</Subtitle>
      </Slide>
      <Slide><Quote style={{fontSize: '4rem'}}>Scope is a mechanism in OAuth 2.0 to <Highlight color={theme}>limit an application's access</Highlight> to a user's account. An application can request one or more scopes, this information is then <Highlight color={theme}>presented to the user in the consent screen</Highlight>, and the <Highlight color={theme}>access token</Highlight> issued to the application will be <Highlight color={theme}>limited to the scopes granted</Highlight>.</Quote><a href="https://oauth.net/2/scope/" title="OAuth's scopes defenition" style={{ color: "#000", borderColor: theme, fontSize: '4rem', marginTop: '4rem' }}>https://oauth.net/2/scope</a></Slide>  
      <Slide><Text>Scopes are <Highlight color={theme}>permissions</Highlight>, <Highlight color={theme}>granted by the user</Highlight>, to a <Highlight color={theme}>third party</Highlight> when using the <Highlight color={theme}>OAuth 2 or Open ID Connect</Highlight> framework.</Text></Slide>  
      
      <Slide>
        <Subtitle>A Delegation scenario example</Subtitle>
      </Slide>
      <Slide>
        <Text>A user wants to <Highlight color={theme}>import all contacts from their gmail account</Highlight>.</Text>
      </Slide>
      <Slide>
        <Text>The application is going to request the <Highlight color={theme}>contacts.readonly</Highlight> scope.</Text>
      </Slide>
      <Slide>
        <Text>A user will authenticate, and <Highlight color={theme}>approve or deny the requested scopes</Highlight>.</Text>
      </Slide>
      <Slide>
        <Image src={googleScopes} alt="Example of the google consent screen" />
      </Slide>
      <Slide>
        <Text>The application <Highlight color={theme}>can import all contacts if the users approved the scope</Highlight>.</Text>
      </Slide>

      <Slide notes="Scopes can never grant more permissions than the user has assigned to them">
        <Columns>
          <div>
            <div style={{background: theme, color:"#fff", height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '7rem'}}>
              <Subtitle>Permissions</Subtitle>
              <List>
                <li>General authorization concept</li>
                <li>First party</li>
                <li>Granted to the user</li>
                <li>A user usually has no direct control over which roles are assigned to them.</li>
              </List>
            </div>
          </div>
          <div>
            <Subtitle>Scopes</Subtitle>
            <List>
              <li>OAhth 2.0 / OIDC</li>
              <li>Third party (delegation)</li>
              <li>Granted by the user</li>
              <li>Limit what an app can do on behalf of the user</li>
            </List>
          </div>
        </Columns>
      </Slide>
      <Slide>
        <Subtitle><a href="https://auth0.com/blog/on-the-nature-of-oauth2-scopes/" title="On the nature of scopes" style={{ color: "#000", borderColor: theme }}>https://auth0.com/blog/on-the-nature-of-oauth2-scopes/</a></Subtitle>
        <Text style={{marginTop: '4rem'}}>Vittorio Bertocci</Text>
      </Slide>

      <Slide style={{ background: theme }}>
        <Subtitle style={{ letterSpacing: "4rem" }}>Summary</Subtitle>
      </Slide>
      <Slide>
        <Text>Attribute Based Access Control offers a <Highlight color={theme}>fine grained controll</Highlight>, but is quite <Highlight color={theme}>complex</Highlight> and not always necessary.</Text>
      </Slide>
      <Slide>
        <Text>Role Based Access Control defines <Highlight color={theme}>permissions and assigns them to roles</Highlight>. A user can have <Highlight color={theme}>multiple roles</Highlight>.</Text>
      </Slide>
      <Slide>
        <Text>Scopes come into play with a <Highlight color={theme}>delegation scenario</Highlight>, but should <Highlight color={theme}>not be used for first party APIs</Highlight>.</Text>
      </Slide>
       <Slide>
        <Subtitle><a href="https://access.sambego.tech" title="See these slides online" style={{ color: "#000", borderColor: theme }}>access.sambego.tech</a></Subtitle>
      </Slide>

      <Slide>
        <Subtitle>Questions?</Subtitle>
        <Text>
          Come to the <img src={auth0} alt="Auth0 logo" style={{height: '7rem', verticalAlign: 'middle', marginBottom: '9px'}}/> booth. <br/> in the Partners Village.
        </Text>
      </Slide>
      <Slide>
        <Subtitle>Questions?</Subtitle>
        <Text>
          Tweet me <Highlight color={theme}>@sambego</Highlight>.
        </Text>
      </Slide>
      
      <Slide style={{ background: theme }}>
        <Subtitle style={{ letterSpacing: "4rem" }}>Thanks!</Subtitle>
      </Slide>
    </Deck>
  );
}

export default Presentation;